import { PersonalDetails } from '@chilipiper/api-client/src/workspace'

export const getName = (assignee: PersonalDetails | undefined) => {
  if (assignee) {
    return `${assignee.firstName ?? ''} ${assignee.lastName ?? ''}`.trim() || assignee.email
  }
}
